export const BODY_OVERFLOW_FOR_MODAL = 'overflow-hidden';
